module.exports = __webpack_public_path__ + "static/media/gicon-4.8ad3b4f3.png";